import React, { useEffect, useState } from 'react';
import ModalContainer from '../../components/ModalContainer.jsx';
import { Form, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { initialValues, onSubmit, validationSchema } from './addTicketFormikCodes.js';
import GetField from '../../components/GetField.jsx';
import Alert from '../../utils/Alert.js';
import { CircularProgress } from '@mui/material';
import { getAllCustomersEmails } from '../../services/ticketsServices.js';

const AddTicket = () => {
    const [allCustomers, setAllCustomers] = useState([]);

    const navigate = useNavigate();

    const handleGetAllCustomers = async () => {
        try {
            const response = await getAllCustomersEmails();
            if (response.status === 200) {
                const customersInfo = response.data.map(c => {
                    return {
                        text: c.email,
                        value: c.id
                    };
                });
                setAllCustomers(customersInfo);
            }
        } catch (error) {
            Alert(`خطا ${error.response?.status || ""}!`, "در دریافت اطلاعات مشتریان مشکلی رخ داده است!\nلطفاً مجدداً تلاش کنید.", "error");
            return navigate(-1);
        }
    }

    useEffect(() => {
        handleGetAllCustomers();
    }, []);

    const resetCustomerArray = (ev, formik) => {
        if (!formik.values["send_to_all"]) {
            formik.setFieldValue("customer", []);
        }
        formik.setFieldValue("send_to_all", !formik.values["send_to_all"]);
    }

    return (
        <ModalContainer
            alwaysOpen={true}
            fullscreen={false}
            title="افزودن اعلان"
        >
            <Formik
                initialValues={initialValues}
                onSubmit={(values, actions) => onSubmit(values, actions)}
                validationSchema={validationSchema}
                validateOnMount
            >
                {(formik) => {
                    return (
                        <Form className="flex flex-col items-center">
                            {!formik.values["send_to_all"] && (
                                allCustomers.length > 0 ? (
                                    <div className="w-full max-w-screen-sm">
                                        <GetField
                                            control="searchableselect"
                                            name="customer"
                                            formikObject={formik}
                                            label="گیرندگان اعلان:"
                                            options={allCustomers}
                                            title="گیرندگان اعلان را انتخاب کنید"
                                            placeholder="بخشی از ایمیل گیرنده..."
                                        />
                                    </div>
                                ) : (
                                    <div className="mb-3 w-full text-center">
                                        <CircularProgress
                                            size={40}
                                            color="primary"
                                        />
                                    </div>
                                )
                            )}
                            <div className="mb-6 w-full max-w-screen-sm">
                                <GetField
                                    control="switch"
                                    name="send_to_all"
                                    label="ارسال اعلان به تمام کاربران"
                                    formik={formik}
                                    onChange={resetCustomerArray}
                                />
                            </div>
                            <div className="mb-6 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="subject"
                                    type="text"
                                    placeholder="عنوان اعلان"
                                    label="عنوان"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-8 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="textarea"
                                    name="context"
                                    label="متن اعلان:"
                                    placeholder="متن اعلان"
                                    rows={8}
                                    unresizable={true}
                                />
                            </div>
                            <div className="w-full text-center">
                                <GetField
                                    control="submitbutton"
                                    disabledButton={true}
                                    formik={formik}
                                    text="افزودن اعلان"
                                />
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </ModalContainer>
    );
}

export default AddTicket;
